module.exports = __webpack_public_path__ + "media/common/fonts/rs-plugin/revicons/revicons-57fd05d4ae650374c8deeff7c4aae380.ttf";